<div class="base-card">
    <ng-content></ng-content>
</div>